var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
import { TswagClient } from "./../commons/TswagClient";
import { Error as ApiError } from "./../models/V1/Primitives/Error/Error";
import { TaxCodeDefinition } from "./../models/V1/TaxCodeDefinitions/TaxCodeDefinition";
import { SearchResult } from "./../models/V1/TaxCodeDefinitions/Search/SearchResult";
export class TaxCodeDefinitions {
  /**
   * Creates an instance of TaxCodeDefinitions.
   * @param {string} [baseUrl]
   * @param {{ fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }} [http]
   * @memberof TaxCodeDefinitions
   */
  constructor(baseUrl, http) {
    __publicField(this, "http");
    __publicField(this, "baseUrl");
    this.baseUrl = baseUrl;
    this.http = http ? http : window;
  }
  /**
   * @param CopyAsRq_ _copyAsRq
   * @returns Promise<CopyAsRq_>
   * @memberof TaxCodeDefinitions
   */
  copyAs(pCopyAsRq, options = {}) {
    const client = new TswagClient(this.baseUrl + "/api/v1/TaxCodeDefinitions/copy/{id}", "PUT", "application/json; charset=UTF-8", "text/plain, application/json, text/json", options);
    client.addPathParams([{ name: "id", value: pCopyAsRq.id, required: true }]);
    const respDescriptor = {
      headerParams: [],
      items: [{ statusCode: 204 }, { statusCode: 404, clazz: ApiError }, { statusCode: 409, clazz: ApiError }]
    };
    return client.fetch(this.http, respDescriptor);
  }
  /**
   * @param CreateRq_ _createRq
   * @returns Promise<CreateRq_>
   * @memberof TaxCodeDefinitions
   */
  create(pCreateRq, options = {}) {
    const client = new TswagClient(this.baseUrl + "/api/v1/TaxCodeDefinitions", "POST", "application/json; charset=UTF-8", "text/plain, application/json, text/json", options);
    client.addBody({ value: pCreateRq.body });
    const respDescriptor = {
      headerParams: [],
      items: [
        { statusCode: 201, clazz: TaxCodeDefinition },
        { statusCode: 409, clazz: ApiError },
        { statusCode: 422, clazz: ApiError }
      ]
    };
    return client.fetch(this.http, respDescriptor);
  }
  /**
   * @param UpdateRq_ _updateRq
   * @returns Promise<UpdateRq_>
   * @memberof TaxCodeDefinitions
   */
  update(pUpdateRq, options = {}) {
    const client = new TswagClient(this.baseUrl + "/api/v1/TaxCodeDefinitions/{id}", "PUT", "application/json; charset=UTF-8", "text/plain, application/json, text/json", options);
    client.addPathParams([{ name: "id", value: pUpdateRq.id, required: true }]);
    client.addBody({ value: pUpdateRq.body });
    const respDescriptor = {
      headerParams: [],
      items: [{ statusCode: 204 }, { statusCode: 404, clazz: ApiError }, { statusCode: 409, clazz: ApiError }, { statusCode: 422, clazz: ApiError }]
    };
    return client.fetch(this.http, respDescriptor);
  }
  /**
   * @param DeleteRq_ _deleteRq
   * @returns Promise<DeleteRq_>
   * @memberof TaxCodeDefinitions
   */
  delete(pDeleteRq, options = {}) {
    const client = new TswagClient(this.baseUrl + "/api/v1/TaxCodeDefinitions/{id}", "DELETE", "application/json; charset=UTF-8", "text/plain, application/json, text/json", options);
    client.addPathParams([{ name: "id", value: pDeleteRq.id, required: true }]);
    const respDescriptor = {
      headerParams: [],
      items: [{ statusCode: 204 }, { statusCode: 404, clazz: ApiError }, { statusCode: 409, clazz: ApiError }]
    };
    return client.fetch(this.http, respDescriptor);
  }
  /**
   * @param EnabledRq_ _enabledRq
   * @returns Promise<EnabledRq_>
   * @memberof TaxCodeDefinitions
   */
  enabled(pEnabledRq, options = {}) {
    const client = new TswagClient(this.baseUrl + "/api/v1/TaxCodeDefinitions/{id}/enabled", "PATCH", "application/json; charset=UTF-8", "text/plain, application/json, text/json", options);
    client.addPathParams([{ name: "id", value: pEnabledRq.id, required: true }]);
    client.addBody({ value: pEnabledRq.body, isPrimitive: true });
    const respDescriptor = {
      headerParams: [],
      items: [{ statusCode: 204 }, { statusCode: 404, clazz: ApiError }]
    };
    return client.fetch(this.http, respDescriptor);
  }
  /**
   * @param GetByCodeRq_ _getByCodeRq
   * @returns Promise<GetByCodeRq_>
   * @memberof TaxCodeDefinitions
   */
  getByCode(pGetByCodeRq, options = {}) {
    const client = new TswagClient(this.baseUrl + "/api/v1/TaxCodeDefinitions/{returnType}-{code}", "GET", "application/json; charset=UTF-8", "text/plain, application/json, text/json", options);
    client.addPathParams([
      { name: "returnType", value: pGetByCodeRq.returnType, required: true },
      { name: "code", value: pGetByCodeRq.code, required: true }
    ]);
    const respDescriptor = {
      headerParams: [],
      items: [
        { statusCode: 200, clazz: TaxCodeDefinition },
        { statusCode: 404, clazz: ApiError }
      ]
    };
    return client.fetch(this.http, respDescriptor);
  }
  /**
   * @param SearchRq_ _searchRq
   * @returns Promise<SearchRq_>
   * @memberof TaxCodeDefinitions
   */
  search(pSearchRq, options = {}) {
    const client = new TswagClient(this.baseUrl + "/api/v1/TaxCodeDefinitions/search", "POST", "application/json; charset=UTF-8", "text/plain, application/json, text/json", options);
    client.addBody({ value: pSearchRq.body });
    const respDescriptor = {
      headerParams: [],
      items: [{ statusCode: 200, clazz: SearchResult }]
    };
    return client.fetch(this.http, respDescriptor);
  }
}
export var GetByCodeReturnType = /* @__PURE__ */ ((GetByCodeReturnType2) => {
  GetByCodeReturnType2["VATOrOSS"] = "VATOrOSS";
  GetByCodeReturnType2["IOSS"] = "IOSS";
  return GetByCodeReturnType2;
})(GetByCodeReturnType || {});
